export const modalConfig = {
  width: 700,
  height: 'auto' as const,
  contentPadding: { vertical: 24, horizontal: 16 },
  modalProps: { destroyOnClose: true },
};

export const getModalFooterButtons = (
  onCancel: () => void,
  onConfirm: () => void
) => [
  { key: 'cancel', text: '取消', type: 'default' as const, onClick: onCancel },
  { key: 'confirm', text: '确定', type: 'primary' as const, onClick: onConfirm },
];

export const getModalTitle = (isEditing: boolean) =>
  isEditing ? '编辑返回格式' : '新建返回格式';
